/**
 * Pulls a server-sent message out of an axios-shaped error, if there is one.
 *
 * The backend answers a refused action with a real explanation — "Falta la
 * declaración de beneficio fiscal", "El plan Semilla es solo para unipersonales
 * o SAS en régimen general" — and a handler that swallows it leaves the user
 * with a generic "try again" for errors that retrying cannot fix. Nest does not
 * log a thrown HttpException either, so that message exists ONLY in the HTTP
 * response: discard it in the browser and the reason is gone everywhere.
 *
 * Callers pair it with their generic copy as the fallback:
 *   toast.error(serverMessage(err) ?? t("some.genericError"))
 */
export function serverMessage(err: unknown): string | null {
  const data = (err as { response?: { data?: { message?: unknown } } })?.response
    ?.data?.message;
  // Both shapes get the same blank test. A message that is present but empty
  // is no message: returning "" here would satisfy the `?? t("…generic")`
  // fallback every caller relies on and render an empty toast, which is worse
  // than the generic copy because it says nothing at all.
  const first = Array.isArray(data) ? data[0] : data;
  if (typeof first === "string" && first.trim() !== "") return first;
  return null;
}
